import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {AxiosError} from "axios";
import {setToken} from "../../utils/storage/Token";
import {PostRequest} from '../../hook/useRequest';
import {useToast} from "../../components/FCObjets/FCToast/FCToast";
import './Login.scss';

function Login() {
    const [password, setPassword] = useState("");
    const [login, setLogin] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const toast = useToast();

    const onFinish = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await PostRequest("/authentication/login", {username: login, password});
            setToken(res.data.token);
            window.location.replace("/");
        } catch (e: any) {
            setLoading(false);
            if (e instanceof AxiosError && e.response) {
                const remainingHeader = e.response.headers?.['ratelimit-remaining'];
                const remaining = remainingHeader !== undefined ? parseInt(remainingHeader) : null;

                if (e.response.status === 403) { navigate("/create_account/wait_validate"); return; }
                if (e.response.status === 429) {
                    toast.error(e.response.data.error, "Compte bloqué");
                    return;
                }
                toast.error(e.response.data.error ?? "Erreur inconnue", "Échec de connexion");
                if (remaining !== null && remaining > 0 && remaining <= 3) {
                    toast.warning(`Tentatives restantes : ${remaining}`, "Attention");
                }
            } else {
                toast.error("Erreur de connexion");
            }
        }
    };

    return (
        <div className="loginPage">
            {/* Fond texturé */}
            <div className="loginBg"/>

            {/* Contenu centré */}
            <div className="loginCenter">
                {/* Logo mobile (masqué desktop) */}
                <div className="loginMobileLogo">
                    <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginMobileIcon"/>
                    <h1 className="loginMobileTitle">Free Compta</h1>
                </div>

                {/* Carte */}
                <div className="loginCard">
                    {/* En-tête carte (desktop uniquement) */}
                    <div className="loginCardHeader">
                        <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginCardLogoImg"/>
                        <div className="loginCardLogo">
                            <span className="loginCardLogoText">Free Compta</span>
                        </div>
                    </div>

                    <h2 className="loginCardTitle">Bienvenue</h2>
                    <p className="loginCardSubtitle">Accédez à votre espace sécurisé.</p>

                    <form onSubmit={onFinish} className="loginForm">
                        {/* Utilisateur */}
                        <div className="loginFieldGroup">
                            <label className="loginFieldLabel">Utilisateur</label>
                            <div className="loginFieldWrapper">
                                <span className="material-symbols-outlined loginFieldIcon">person</span>
                                <input
                                    className="loginInput"
                                    type="text"
                                    placeholder="username"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    autoComplete="username"
                                />
                            </div>
                        </div>

                        {/* Mot de passe */}
                        <div className="loginFieldGroup">
                            <div className="loginFieldLabelRow">
                                <label className="loginFieldLabel">Mot de passe</label>
                                <button type="button" className="loginForgot"
                                        onClick={() => navigate("/forgot-password")}>Oublié ?</button>
                            </div>
                            <div className="loginFieldWrapper">
                                <span className="material-symbols-outlined loginFieldIcon">lock</span>
                                <input
                                    className="loginInput"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    className="loginShowPassword"
                                    onClick={() => setShowPassword(v => !v)}
                                    tabIndex={-1}
                                >
                                    <span className="material-symbols-outlined">
                                        {showPassword ? "visibility" : "visibility_off"}
                                    </span>
                                </button>
                            </div>
                        </div>

                        {/* Bouton connexion */}
                        <button type="submit" className="loginBtn" disabled={loading}>
                            {loading ? "Connexion…" : "Se connecter →"}
                        </button>

                        {/* Créer un compte */}
                        <button
                            type="button"
                            className="loginCreateAccount"
                            onClick={() => window.location.replace("/create_account")}
                        >
                            Créer un compte
                        </button>
                    </form>
                </div>
            </div>

            {/* Footer */}
            <footer className="loginFooter">
                <a href="mailto:admin@free-compta.fr" className="loginFooterLink">Besoin d'aide ?</a>
                <span className="loginFooterDot">•</span>
                <span>© {new Date().getFullYear()} FREECOMPTA.</span>
            </footer>
        </div>
    );
}

export default Login;
